<template>
  <div
    id="app"
    :class="{ lightBackground: !isDarkMode, darkBackground: isDarkMode }"
  >
    <router-view />
  </div>
</template>

<script>
import "animate.css";

export default {
  name: "App",
  computed: {
    isDarkMode() {
      return this.$store.getters.isDarkMode;
    }
  },
  mounted() {
    const isDarkMode = this.$store.getters.isDarkMode;
    document.body.style.background = isDarkMode ? "#1f1f1f" : "#f0f3f5";
  }
};
</script>

<style lang="scss">
* {
  transition: 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
}

#app {
  font-family: $systemFontFamily;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $white;
}

body {
  margin: 0;
}

h1 {
  @include heading1;
}

p {
  @include largeTextBold($purple);
}

h3.light {
  @include heading3();
}

h3.dark {
  @include heading3($black);
}

h4 {
  line-height: 34px;
  font-size: 24px;
  text-align: center;
  color: #ffffff;
  margin: 0;
}

input {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-sizing: border-box;
  border-radius: 4px;
  height: 60px;
  width: 100%;
  font-size: 20px;
  color: white;
  padding-left: 20px;
  margin-top: 20px;
  &::placeholder {
    color: rgba(255, 255, 255, 0.3);
  }
}

.lightInput {
  color: $white;
}

.darkInput {
  color: $black;
}

button {
  background: #56ccf2;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  height: 60px;
  width: 100%;
  font-size: 20px;
  color: #ffffff;
  border: none;
  margin-top: 20px;
  margin-bottom: 40px;
}

a {
  line-height: 25px;
  text-align: center;
  text-decoration: none;
}

// Theme
.lightBackground {
  background-color: $lightBackground;
}

.darkBackground {
  background-color: $darkBackground;
}

.lightText {
  color: $white;
}

.darkText {
  color: $black;
}

.lightField {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);

  &::placeholder {
    color: rgba(255, 255, 255, 0.3);
  }
}

.darkField {
  background: rgba(198, 208, 235, 0.2);
  border: 1px solid rgba(0, 0, 0, 0.2);

  &::placeholder {
    color: rgba(0, 0, 0, 0.3);
  }
}

.lightLink {
  color: rgba(255, 255, 255, 0.3);
}

.darkLink {
  color: rgba(0, 0, 0, 0.3);
}
</style>
